import React from 'react';

import Fields from 'ui/form/FieldsForm';

import { LICENSE_TYPE, SUBSCRIPTIONS, AGREE_TEXT } from '../consts';

export default function LicensePart({
    values,
    errors,
    agree,
    creating,
    onChange,
    children,
}) {
    const changeFactory = name => value => onChange(name, value);

    return (
        <React.Fragment>
            {creating && (
                <Fields.Select
                    label="Type"
                    error={errors.license_type}
                    value={values.license_type}
                    onChange={changeFactory('license_type')}
                    options={LICENSE_TYPE}
                    half
                    oneLine
                />
            )}
            <Fields.Select
                label="Subscription level"
                value={values.subscription_level}
                error={errors.subscription_level}
                onChange={changeFactory('subscription_level')}
                options={SUBSCRIPTIONS}
                half
                oneLine
            />
            <Fields.Text
                label="User license count"
                type="number"
                inputProps={{ min: 1 }}
                error={errors.seats}
                value={values.seats}
                onChange={changeFactory('seats')}
                half
                oneLine
            />
            {children}
            {(creating || agree) && (
                <Fields.CheckBox
                    label={AGREE_TEXT}
                    error={errors.licenseAck}
                    checked={!!values.licenseAck}
                    onChange={changeFactory('licenseAck')}
                />
            )}
        </React.Fragment>
    );
}
